<template>
  <v-card elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Datos generales</h6>
      <p class="text-body-2">Ingrese los datos basicos del remito</p>
      <v-row class="mt-0">
        <v-col md="4" class="mt-2">
          <v-combobox
            :loading="loading_supplier"
            v-model="item.supplier"
            data-vv-as="proveedor"
            name="supplier"
            item-text="name"
            item-value="id"
            :items="suppliers"
            label="Proveedor*"
            autocomplete="off"
            v-validate="'required|combobox_required'"
            :disabled="isViewModal || loading_num_remito || item.id > 0"
          ></v-combobox>
          <span class="red--text">{{ errors.first("supplier") }}</span>
        </v-col>

        <v-col md="4" class="mt-2">
          <v-combobox
            :loading="loading_receiver"
            v-model="item.receiver"
            data-vv-as="receptor"
            name="receiver"
            item-text="name"
            item-value="id"
            :items="receivers"
            label="Receptor*"
            autocomplete="off"
            v-validate="'required|combobox_required'"
            :disabled="isViewModal || (item.id > 0 && item.state.id !== 0)"
          ></v-combobox>
          <span class="red--text">{{ errors.first("receiver") }}</span>
        </v-col>
        <v-col md="4" class="mt-2">
          <DatePickerEsp
            :initToday="true"
            label="Fecha"
            :date="item.cbte_fch"
            :isRequired="true"
            name="cbte_fch"
            @setDate="
              (date) => {
                item.cbte_fch = date;
              }
            "
            :isViewModal="isViewModal"
          />
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col md="4" class="mt-2">
          <v-text-field
            autocomplete="off"
            data-vv-as="numero de remito"
            label="Numero remito* (formato: 00001-00000001)"
            name="num_remito"
            v-validate="'required|max:20|afip_format'"
            v-model="item.num_remito"
            :disabled="isViewModal"
            :loading="loading_num_remito"
            @blur="validateAndAutocomplete"
          >
          </v-text-field>
          <span class="red--text">{{ errors.first("num_remito") }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import Constant from "@/constants/sections";
import { emmiterService } from "@/libs/ws/emmiterService";
import { suppliersService } from "@/libs/ws/suppliersService";
import { purchaseRemitoService } from "@/libs/ws/purchaseRemitoService";

import DatePickerEsp from "@/components/DatePickerEsp.vue";
export default {
  components: { DatePickerEsp },
  props: { item: Object, isViewModal: Boolean, validator: Object },
  created() {
    this.$validator = this.validator;
    
    // Registrar validación personalizada para formato ARCA
    this.$validator.extend('afip_format', {
      getMessage: field => `El ${field} debe tener el formato 00001-00000001 (5 dígitos, guión, 8 dígitos)`,
      validate: value => {
        if (!value) return true; // Si está vacío, lo maneja 'required'
        return /^\d{5}-\d{8}$/.test(value);
      }
    });
  },
  data: () => ({
    remitosWS:purchaseRemitoService,
    receivers: [],
    suppliers: [],
    ptosvtas: [],
    loading_supplier: false,
    loading_receiver: false,
    loading_num_remito: false,
    supplier_selected: null,
  }),
  watch: {
    item: {
      handler: function (newValue) {
        if ((this.supplier_selected == null && newValue.supplier != null) || (newValue.supplier != null && this.supplier_selected.id != newValue.supplier.id)) {
          this.supplier_selected = newValue.supplier;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getCombobox();
  },
  methods: {
    validateAndAutocomplete() {
      const numRemito = this.item.num_remito;
      
      // Si es null o undefined, no hacemos nada
      if (!numRemito) {
        return;
      }

      if (numRemito.length > 20) {
        this.item.num_remito = numRemito.slice(0, 20);
      }

      const afipRegex = /^\d{1,5}-\d{1,8}$/;
      if (afipRegex.test(numRemito)) {
        const parts = numRemito.split("-");
        if (parts.length === 2) {
          const pointOfSale = parts[0].padStart(5, "0");
          const invoiceNumber = parts[1].padStart(8, "0");
          this.item.num_remito = `${pointOfSale}-${invoiceNumber}`;
        }
      }
    },
    getCombobox() {
      this.loading_receiver = true;
      emmiterService
        .filter({ enabled: true })
        .then((response) => {
          this.receivers = response.result;
          if (response.result.length == 1) {
            this.item.receiver = response.result[0];
          }
        })
        .finally(() => {
          this.loading_receiver = false;
        });

      this.loading_supplier = true;
      suppliersService
        .filter({})
        .then((response) => {
          this.suppliers = response.result;
        })
        .finally(() => {
          this.loading_supplier = false;
        });
    },
  },
};
</script>
